import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ledgerDelete, groupDelete, ledgerList, closeModal, openModal, saveChartOfAccountsState } from '../../../../../redux/actions/action-creator';
import { Link, useNavigate, useParams, useLocation, useNavigationType } from 'react-router-dom';
import MasterListFooter from '../../../../../components/Footer/Master_Footer/MasterListFooter';
import { useDropdownKeyboardNavigation } from '../../../../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import { useDropdownScroll } from '../../../../../components/Custom_Hooks/useDropdownScroll';
import { currencyFormate } from "../../../../../components/Date_Formate_Utilitiy/Index";
import HomeLayout from '../../../../../components/home_page/HomeLayout';
import Form from '../../../../../components/Form/Form';
import NavFooterLayout from '../../../../../components/NavNameOfComponent/NavFooterLayout';
import DeletConfirm from '../../../../../components/Modal/DeletConfirm';
import { useDelet } from '../../../../../components/Custom_Hooks/useDelete';
import { prepareFormData } from '../../../../../components/Custom_Hooks/useFormHandler';
import GroupAlter from '../../alter/accounting_masters/GroupAlter';
import LedgerAlter from '../../alter/accounting_masters/Ledger';
import GroupView from '../../view/accounting_masters/GroupView';
import LedgerView from '../../view/accounting_masters/LedgerView';
import GroupCreate from '../../create/accounting_masters/Group';
import LedgerCreate from '../../create/accounting_masters/Ledger';

const Ledger = () => {
    const { id } = useParams()
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const [loading, setLoading] = useState(true);
    const [all_data, setall_data] = useState([])
    const [ledger_length, setledger_length] = useState(0)
    const [group_length, setgroup_length] = useState(0)

    const { userData } = useSelector(state => state.auth);
    const modal_state = useSelector(state => state.common.modal_state);
    const persistedState = useSelector(state => state.common.chart_of_accounts_persisted_state?.ledger);
    const navigationType = useNavigationType();
    const isBackNavigation = navigationType === 'POP';
    const localSelectionRef = useRef(null);
    const dropdownRef = useRef(null);
    const [enabled, setEnabled] = useState(true);
    const prevModal2Ref = useRef(false);


    // fetch data ----------------------------------
    useEffect(() => {
        const wasOpen = prevModal2Ref.current;
        const isOpen = !!modal_state?.modal_2;
        prevModal2Ref.current = isOpen;

        if (isOpen) return;

        if (wasOpen && !isOpen) {
            if (!window.deleteSuccess) {
                return;
            }
            window.deleteSuccess = false;
        }

        setEnabled(true);
        const fetchData = async () => {
            try {
                const formdata = new FormData();
                formdata.append('company_id', userData?.company_id);
                const response = await dispatch(ledgerList(formdata));
                const processGroups = (groups, type, under) => {
                    let groupCount = 0;
                    let ledgerCount = 0;
                    const array_list = [];
                    groups.forEach(group => {
                        array_list.push({ type, data: group, under: group.under });
                        if (group?.groupName) {
                            const { groupCount: subGroupCount, ledgerCount: subLedgerCount, array_list: subArray } = processGroups(group.groupName, type + 1, group.name);
                            groupCount += subGroupCount;
                            ledgerCount += subLedgerCount;
                            array_list.push(...subArray);
                        }
                        if (group.ledger) {
                            ledgerCount += group.ledger.length;
                            array_list.push(...group.ledger.map(ledger => ({ type: type + 1, data: ledger, under: group.name })));
                        }
                    });

                    groupCount += groups.length;
                    return { groupCount, ledgerCount, array_list };
                };

                if (response.data && response.data.length > 0) {
                    const { groupCount, ledgerCount, array_list } = processGroups(response.data, 'Primary', 'Primary');

                    const sortedData = [...array_list].sort((a, b) => {
                        const nameA = (a.data.name || a.data.ledger_name || "").toLowerCase();
                        const nameB = (b.data.name || b.data.ledger_name || "").toLowerCase();

                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;
                        return 0;
                    });
                    // filter data to show only ledger data
                    const filteredData = sortedData.filter(item => item.data.ledger_name);
                    setall_data(filteredData);
                    const itemNameToRestore = isBackNavigation ? persistedState?.selectedItemName : localSelectionRef.current;
                    if (itemNameToRestore) {
                        const index = filteredData.findIndex(item => (item.data.ledger_name || item.data.name) === itemNameToRestore);
                        if (index !== -1) setSelectedItemIndex(index);
                        else setSelectedItemIndex(0);
                    } else {
                        setSelectedItemIndex(0);
                    }
                    setledger_length(ledgerCount);
                    setgroup_length(groupCount - 4);
                    // Now you have groupCount and ledgerCount containing the lengths of groups and ledgers respectively
                } else {
                    setall_data([]);
                }
            } catch (error) {
                console.error('Error fetching ledger data:', error);
            } finally {
                setLoading(false);

            }
        };
        fetchData();
    },
        [
            /*modal_state?.group_view,
            modal_state?.group_update,*/
            modal_state?.ledger_view,
            modal_state?.ledger_update,
            modal_state?.ledger_create,
            //modal_state?.modal_1,
            modal_state?.modal_2,
            location
        ]);


    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: all_data,
        state: modal_state?.ledger_view || modal_state?.ledger_update || modal_state?.ledger_create || modal_state?.modal_2 ? false : true,
        initialIndex: 0,
        enableAlphaJump: true,
        getLabel: (item) => item?.data?.ledger_name || item?.data?.name || '',
        onItemSelect: (item) => {
            if (item?.data?.id) {
                // navigate(`../alter_accounting_groupupdate/${item?.data?.id}`)
                dispatch(saveChartOfAccountsState({ ledger: { selectedItemName: item?.data?.ledger_name || item?.data?.name, selectedItemIndex } }));
                dispatch(openModal('ledger_view'))
            }
        },
        onItemControlEnterSelect: (item) => {
            if (item?.data?.id) {
                if (!(modal_state?.ledger_view || modal_state?.ledger_create || modal_state?.modal_2)) {
                    dispatch(saveChartOfAccountsState({ ledger: { selectedItemName: item?.data?.ledger_name || item?.data?.name, selectedItemIndex } }));
                    dispatch(openModal('ledger_update'))
                }
            }
        },
        onItemAltCSelect: (item) => {
            if (item?.data?.name === 'Assets' || item?.data?.name === 'Expenses' || item?.data?.name === 'Income' || item?.data?.name === 'Liabilities') { return }
            if (!(modal_state?.ledger_update || modal_state?.modal_2 || modal_state?.ledger_view)) {
                // If list is empty (item is undefined) or if it's a ledger item, open ledger_create
                if (!item || item?.data?.ledger_name) {
                    dispatch(saveChartOfAccountsState({ ledger: { selectedItemName: item?.data?.ledger_name || item?.data?.name, selectedItemIndex } }));
                    dispatch(openModal('ledger_create'))
                }
            }
        },
        onItemAltDSelect: (item) => {
            if (item?.data?.id) {
                if (!(modal_state?.ledger_update || modal_state?.ledger_create || modal_state?.ledger_view)) {
                    dispatch(saveChartOfAccountsState({ ledger: { selectedItemName: item?.data?.ledger_name || item?.data?.name, selectedItemIndex } }));
                    dispatch(openModal('modal_2'))
                }
            }
        },
    });

    useEffect(() => {
        if (selectedItemIndex !== undefined && all_data[selectedItemIndex]) {
            const currentItem = all_data[selectedItemIndex];
            const name = currentItem.data?.ledger_name || currentItem.data?.name;
            localSelectionRef.current = name;
            if (name && !modal_state?.ledger_view && !modal_state?.ledger_update && !modal_state?.ledger_create && !modal_state?.modal_2) {
                dispatch(saveChartOfAccountsState({ ledger: { selectedItemName: name, selectedItemIndex } }));
            }
        }
    }, [selectedItemIndex, all_data]);
    // Scroll Functionality -------------------------------------
    useDropdownScroll({ dropdownRef, selectedItemIndex });

    const [data, setData] = useState({
        id: all_data[selectedItemIndex]?.data?.id,
        company_id: userData?.company_id
    })

    useEffect(() => {
        if (all_data[selectedItemIndex]) {
            setData({
                id: all_data[selectedItemIndex]?.data?.id,
                company_id: userData?.company_id,
            });
        }
    }, [selectedItemIndex, all_data]);

    // Delete Functionality ------------------------------
    const { delteItem, loadingDelete } = useDelet({
        prepareFormData: () => prepareFormData(data),
        submitForm: (data) => dispatch(all_data[selectedItemIndex]?.data?.name ? groupDelete(data) : ledgerDelete(data)),
        shortcuts: [
            {
                key: 'a',
                ctrlKey: true,
                action: () => delteItem(new Event('submit')),
            },
        ],
        closeModal: () => dispatch(closeModal('modal_2')),
        state: modal_state?.modal_2
    });
    return (
        <HomeLayout>
            /*{modal_state?.modal_1 && (
                <div style={{ zIndex: 10000 }}>
                    <GroupCreate
                        title='Group Creation (Primary)'
                        closeModal_sec={() => dispatch(closeModal('modal_1'))}
                    />
                </div>)}*/
            {modal_state?.ledger_create && (
                <div style={{ zIndex: 10000 }}>
                    <LedgerCreate
                        title='Ledger Creation (Primary)'
                        closeModal_sec={() => dispatch(closeModal('ledger_create'))}
                    />
                </div>)}
            /*{
                // location.pathname === `/alter_accounting_groupupdate/${id}`
                modal_state?.group_update
                && (
                    <div style={{ zIndex: 10000 }}>
                        <GroupAlter
                            data_to_update={data}
                            title='Group Alteration'
                            closeModal_sec={() => dispatch(closeModal('group_update'))}
                        />
                    </div>
                )}*/
            {
                // location.pathname === `/alter_accounting_groupupdate/${id}`
                modal_state?.ledger_update
                && (
                    <div style={{ zIndex: 10000 }}>
                        <LedgerAlter
                            data_to_update={data}
                            title='Ledger Alteration'
                            closeModal_sec={() => dispatch(closeModal('ledger_update'))}
                        />
                    </div>
                )}
            /*{
                // location.pathname === `/alter_accounting_groupupdate/${id}`
                modal_state?.group_view
                && (
                    <div style={{ zIndex: 10000 }}>
                        <GroupView
                            data_to_view={data}
                            title='Group View'
                            closeModal_sec={() => dispatch(closeModal('group_view'))}
                        />
                    </div>
                )}*/
            {
                // location.pathname === `/alter_accounting_groupupdate/${id}`
                modal_state?.ledger_view
                && (
                    <div style={{ zIndex: 10000 }}>
                        <LedgerView
                            data_to_view={data}
                            title='Ledger View'
                            closeModal_sec={() => dispatch(closeModal('ledger_view'))}
                        />
                    </div>
                )}
            <Form
                title='List of Ledger'
                col='col-12'
                loading={loading}
                Footer={MasterListFooter}
                createMasterEnabled={enabled}
            >
                {
                    modal_state?.modal_2 ?
                        <div style={{ zIndex: 10000 }}>
                            <DeletConfirm
                                handleSubmit={delteItem}
                                loading={loadingDelete}
                                closeModal={() => dispatch(closeModal('modal_2'))}
                            />
                        </div>
                        : null
                }
                <div className="row p-0 m-0 border_2_1px_top border_2_2px_bottom mt-0">
                    <div
                        className="col-1 font_size p-0 m-0 px-1 text-end fw-bold"
                        style={{ width: "3%" }}
                    >
                        Sr
                    </div>
                    <div
                        className="col-4 font_size p-0 m-0 px-1 text-start fw-bold"
                        style={{ width: "30%" }}
                    >
                        Name of Ledger
                    </div>
                    <div
                        className="col-1 font_size m-0 p-0 px-1 text-start fw-bold"
                        style={{ width: "10%" }}
                    >
                        City
                    </div>
                    <div
                        className="col-1 font_size m-0 p-0 px-1 text-end fw-bold"
                        style={{ width: "5%" }}
                    >
                        A/C No.
                    </div>
                    <div
                        className="col-1 font_size m-0 p-0 px-1 text-start fw-bold"
                        style={{ width: "22.5%" }}
                    >
                        Group Name
                    </div>
                    <div
                        className="col-1 font_size m-0 p-0 px-1 text-end fw-bold"
                        style={{ width: "8%" }}
                    >
                        Mobile
                    </div>
                    <div
                        className="col-2 font_size m-0 p-0 px-1 text-end fw-bold"
                        style={{ width: "10%" }}
                    >
                        Aadhaar
                    </div>
                    <div
                        className="col-1 font_size m-0 p-0 px-1 text-end fw-bold"
                        style={{ width: "10%" }}
                    >
                        Opening Balance
                    </div>
                    <div
                        className="col-1 font_size p-0 m-0 ps-0 text-start fw-bold"
                        style={{ width: "1.5%" }}
                    >
                    </div>
                </div>
                <div className='row gx-0 p-0 mb-2' style={{ overflowY: 'hidden' }}>
                    <div className='col m-0 p-0' ref={dropdownRef} style={{ overflowY: 'auto', height: '75.3vh' }}>
                        {
                            all_data.map((item, index) => {
                                if (item.data.ledger_name && item.data.ledger_name != '') {
                                    return (
                                        <div
                                            key={index}
                                            onClick={() => setSelectedItemIndex(index)}
                                            style={{
                                                cursor: "pointer",
                                                marginLeft: item.type === 'primary' ? 0 : item.type === 'secondary' ? 10 : item.type.startsWith('secondary') ? (item.type.length - 6) * 5 : 0
                                            }}
                                            className={`row gx-0 p-0 m-0  mt-0 ${index === selectedItemIndex ? "selected" : ""}`}>
                                            <div
                                                className="col-1 font_size p-0 m-0 px-1 text-end"
                                                style={{ width: "3%" }}
                                            >
                                                {index + 1}
                                            </div>
                                            <div
                                                className="col-4 font_size p-0 m-0 px-1 text-start"
                                                style={{ width: "30%" }}
                                            >
                                                {item?.data?.name || item?.data?.ledger_name}
                                            </div>
                                            <div
                                                className="col-1 font_size m-0 p-0 px-1 text-start"
                                                style={{ width: "10%" }}
                                            >
                                                {item?.data?.city}
                                            </div>
                                            <div
                                                className="col-1 font_size m-0 p-0 px-1 text-end"
                                                style={{ width: "5%" }}
                                            >
                                                {item?.data?.account_no}
                                            </div>
                                            <div
                                                className="col-1 font_size m-0 p-0 px-1 text-start"
                                                style={{ width: "22.5%" }}
                                            >
                                                {item?.under}
                                            </div>
                                            <div
                                                className="col-1 font_size m-0 p-0 px-1 text-end"
                                                style={{ width: "8%" }}
                                            >
                                                {item?.data?.mobile_no}
                                            </div>
                                            <div
                                                className="col-2 font_size m-0 p-0 px-1 text-end"
                                                style={{ width: "10%" }}
                                            >
                                                {item?.data?.aadhaar}
                                            </div>
                                            <div
                                                className="col-1 font_size m-0 p-0 px-1 text-end"
                                                style={{ width: "10%" }}
                                            >
                                                {(Number(item?.data?.opening_amt) && item?.data?.type === 'Cr') ? '-' : ''}{currencyFormate(Number(item?.data?.opening_amt || 0).toFixed(2))}
                                            </div>
                                            <div
                                                className="col-1 font_size p-0 m-0 ps-0 text-start"
                                                style={{ width: "1.5%" }}
                                            >
                                                {Number(item?.data?.opening_amt) ? item?.data?.type : ''}
                                            </div>
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>
                </div>
                <NavFooterLayout>
                    <b className='ps-2'> {ledger_length} Ledger(s)</b>
                </NavFooterLayout>

            </Form>
        </HomeLayout>
    )
}
export default Ledger